import { createMemoryStore } from "../../../lib/store";

// Bumped by the desktop sidebar's "New conversation". The new-chat page is keyed
// on it, so that click starts over even when the page is already showing, and
// nothing else remounts it: the router REPLACE that consumes a hand-off
// (`initialQuestion`) keeps the page, and its question, in place.
export const useNewChatGeneration = createMemoryStore(0);
